module.exports = __webpack_public_path__ + "img/sumary_lifetime_co2.b28f8cf8.svg";